import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Settlement } from 'src/app/classes/settlement.class';
import { User } from 'src/app/classes/user.class';
import { CodaltComponent } from 'src/app/codalt.component';
import { NON_TIME_HOURTYPES } from 'src/app/services/settlements.service';
import { ResettleDifference, ResettleService } from './resettle.service';

@Component({
    selector: 'app-resettle-diff-dialog',
    templateUrl: './resettle-diff-dialog.component.html',
    styleUrls: ['./resettle-diff-dialog.component.scss'],
    standalone: false,
})
export class ResettleDiffDialogComponent extends CodaltComponent {
    differences: ResettleDifference[];

    recalculateTravel: boolean;

    /** Voortgang tijdens het opslaan. */
    progress = { done: 0, total: 0 };

    saving = false;

    constructor(
        public dialogRef: MatDialogRef<ResettleDiffDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            differences: ResettleDifference[];
            recalculateTravel: boolean;
            employee: Readonly<User>;
            /**
             * Meegegeven door de aanroeper: `ResettleService` hangt aan de periodeverrekening en
             * zit niet in de injector van de dialoog.
             */
            resettleService: ResettleService;
        }
    ) {
        super();

        this.differences = data.differences;
        this.recalculateTravel = data.recalculateTravel;
    }

    get progressPercentage() {
        return this.progress.total ? (this.progress.done / this.progress.total) * 100 : 0;
    }

    get correctable() {
        return this.differences.filter(d => d.correctable);
    }

    get accepted() {
        return this.correctable.filter(d => d.useRecalculated);
    }

    /** `CRW` telt kilometers, de overige uursoorten minuten. */
    isDistance(hourtypeCode: string) {
        return NON_TIME_HOURTYPES.includes(hourtypeCode);
    }

    /** Terug naar de keuzes; de aanroeper opent die opnieuw. */
    changeOptions() {
        this.dialogRef.close({ changeOptions: true });
    }

    /** Slaat de gekozen correcties op; de dialoog blijft open zolang dat loopt. */
    async confirm() {
        if (this.saving) {
            return;
        }

        this.saving = true;

        this.dialogRef.disableClose = true;

        let created: Settlement[];

        try {
            created = await this.data.resettleService.applyCorrections(
                this.accepted,
                this.data.employee,
                (done, total) => (this.progress = { done, total })
            );
        } catch (error) {
            this.saving = false;

            this.dialogRef.disableClose = false;

            this.dialogRef.close({ failed: true, error });

            return;
        }

        this.dialogRef.close({ created });
    }
}
